import React from 'react'

const ClientTestimonials = () => {
  return (
    <div className='text-client-quote-color flex flex-col justify-center w-full text-center lg:w-[630px] tracking-[1.7px] px-4  leading-7 gap-10'>
        <div>
            <div className='text-[12px]'>
              <span className='block'>"I rented a flat with Zande for the last year - everything went smoothly, from move-in to check-out.</span>
              <span className='block'>I didn't have to reach out about much during the tenancy, but when I did they were really responsive and had 
                things sorted out straight away.</span>
                <span className='block'>Really friendly, professional group of guys, and the best I've rented with in United State of America."</span>
            </div>
            <div className='text-darker-name-color mt-4 text-[12px]'>
            - Harry A
            </div>
        </div>

        <div>
            <div className='text-[12px]'>
              <span className='block'>"I rented a beautiful flat with Zande for the past 2 years.</span>
              <span className='block'>They have been so helpful in making my entire stay very pleasant..</span>
                <span className='block'>They are extremely reliable, friendly and most of all professionally, one couldn't ask more.</span>
                <span className='block'>I highly recommended them.</span>
                <span className='block'>Keep up the good work!"</span>
            </div>
            <div className='text-darker-name-color mt-4 text-[12px]'>
            - Cecelia T
            </div>
        </div>

        <div>
            <div className='text-[12px]'>
              <span className='block'>"My wife and I rented a property from Zande for about five years and had a great experience.</span>
              <span className='block'>They were very prompt with repairs, and they were very fair and transparent with the move-in and move-out.</span>
              <span className='block'>Overall, I consider them a very reputable agency and would gladly rent from them again!"</span>
            </div>
            <div className='text-darker-name-color mt-4 text-[12px]'>
            - David R
            </div>
        </div>

        <div>
            <div className='text-[12px]'>
              <span className='block'>"I used Zande originally to help find me an investment property in the W11 area approximately three years ago.</span>
              <span className='block'>I was very impressed with their knowledge of the industry and insight into the areas we were interested in.</span>
              <span className='block'>They worked extremely hard to find a suitable property for us in a couple of months.</span>
              <span className='block'>We have since used them as Management Agents for the property.</span>
              <span className='block'>In this regard, they have provided us with high quality service and excellent communication.</span>
              <span className='block'>I would wholeheartedly recommend them."</span>
            </div>
            <div className='text-darker-name-color mt-4 text-[12px]'>
            - Al
            </div>
        </div>

        <div>
            <div className='text-[12px]'>
              <span className='block'>"Zande have been managing our properties for a number of years now.</span>
              <span className='block'>They're a truly professional & trustworthy outfit.</span>
              <span className='block'>They listen and do their best for us at the most competitive prices.</span>
              <span className='block'>Certainly am very impressed all round with their performance and would most definitely recommend them."</span>
            </div>
            <div className='text-darker-name-color mt-4 text-[12px]'>
            - K Mehr
            </div>
        </div>

        <div>
            <div className='text-[12px]'>
              <span className='block'>"As you know, I have always been very pleased with your service.</span>
              <span className='block'>Having worked together on a number of projects and seen how you handle various situations, 
                  I find you to be firm yet fair, with a genuine desire to find win-win solutions, which is so rare in this industry."</span>
            </div>
            <div className='text-darker-name-color mt-4 text-[12px]'>
            - Joe K
            </div>
        </div>

        <div>
            <div className='text-[12px]'>
              <span className='block'>"I cannot think of a better Agent than Zande.</span>
              <span className='block'>They are reliable, super friendly, helpful and honest people.</span>
                <span className='block'>It has been the best agent we have dealt with so far."</span>
            </div>
            <div className='text-darker-name-color mt-4 text-[12px]'>
            - Anabel F.
            </div>
        </div>
    </div>
  )
}

export default ClientTestimonials